export const GRAPHQL_API_ENDPOINT = "https://api.tropicalfoodtruck.se/graphql";
export const MEDIA_API_ENDPOINT = "https://api.tropicalfoodtruck.se/media";
